import api from '@/utils/api'

export type FeedbackType = 'question_error' | 'answer_error' | 'explanation_error' | 'other'
export type FeedbackStatus = 'pending' | 'processing' | 'resolved' | 'rejected'

export interface Feedback {
  id: number
  userId: number
  questionId: number | null
  type: FeedbackType
  content: string
  status: FeedbackStatus
  adminReply?: string
  handledBy?: number
  handledAt?: string
  createdAt: string
  updatedAt: string
  user?: {
    id: number
    username: string
    firstName?: string
    lastName?: string
  }
  question?: {
    id: number
    question: string
    questionBank?: {
      domain: string
      subdomain: string
    }
  } | null
  handler?: {
    id: number
    username: string
    firstName?: string
    lastName?: string
  }
}

export interface FeedbackListResponse {
  data: Feedback[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export interface UpdateFeedbackStatusDto {
  status: FeedbackStatus
  adminReply?: string
}

export interface CreateFeedbackDto {
  questionId?: number
  type: FeedbackType
  content: string
}

export interface UpdateUserFeedbackDto {
  type: FeedbackType
  content: string
}

export const feedbackApi = {
  // 获取当前用户的反馈
  async getMyFeedbacks(page: number = 1, limit: number = 10): Promise<FeedbackListResponse> {
    const response = await api.get('/feedback/my', { params: { page, limit } })
    return response.data
  },

  // 提交题目反馈或不针对题目的通用反馈
  async createFeedback(data: CreateFeedbackDto): Promise<Feedback> {
    const response = await api.post('/feedback', data)
    return response.data
  },

  // 修改当前用户自己的反馈
  async updateMyFeedback(id: number, data: UpdateUserFeedbackDto): Promise<Feedback> {
    const response = await api.patch(`/feedback/my/${id}`, data)
    return response.data
  },

  // 管理员获取所有反馈
  async getAllFeedbacks(page: number = 1, limit: number = 10): Promise<FeedbackListResponse> {
    const response = await api.get('/feedback/admin/all', {
      params: { page, limit }
    })
    return response.data
  },

  // 获取反馈详情
  async getFeedbackDetail(id: number): Promise<Feedback> {
    const response = await api.get(`/feedback/${id}`)
    return response.data
  },

  // 更新反馈状态
  async updateFeedbackStatus(id: number, data: UpdateFeedbackStatusDto): Promise<Feedback> {
    const response = await api.patch(`/feedback/${id}/status`, data)
    return response.data
  }
}
